import React from 'react'
import { IconProps } from './icons.models';

const FilterIcon: React.FC<IconProps> = ({
    width = 16,
    height = 16,
    className,
    onClick,
    fillColor = 'white',
}) => {
    return (
        <svg className={className} onClick={onClick} width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.33333 0.5H14.6667C14.8877 0.5 15.0996 0.58919 15.2559 0.747949C15.4122 0.906708 15.5 1.12203 15.5 1.34655V2.68918C15.5 2.91368 15.4121 3.12897 15.2558 3.28769L9.91083 8.71746C9.75454 8.87618 9.66671 9.09147 9.66667 9.31597V14.6535C9.66666 14.7822 9.63778 14.9091 9.58222 15.0248C9.52666 15.1404 9.44587 15.2417 9.34601 15.3208C9.24615 15.4 9.12983 15.455 9.00591 15.4816C8.88198 15.5083 8.75371 15.5059 8.63083 15.4746L6.96417 15.0514C6.78396 15.0055 6.62401 14.8998 6.50971 14.751C6.39542 14.6022 6.33334 14.4189 6.33333 14.2302V9.31597C6.33329 9.09147 6.24546 8.87618 6.08917 8.71746L0.744167 3.28769C0.587876 3.12897 0.500047 2.91368 0.5 2.68918V1.34655C0.5 1.12203 0.587797 0.906708 0.744078 0.747949C0.900358 0.58919 1.11232 0.5 1.33333 0.5Z" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default FilterIcon;